import { AvatarUploading } from '@/components/ui/avatar-uploading';

export const PhotoForm = () => {
	return (
		<div className="w-full text-white">
			<AvatarUploading />
		</div>
	);
};
